import React, { Component } from 'react';
import { ComboBox } from '@progress/kendo-react-dropdowns';
import { Button } from '@progress/kendo-react-buttons';
import { getProjectAndCrListData, getUnfreezeRequestData, getRMAllocationData, getResourceHolidaysData } from './PMOReportService';
import ProjectAndCrExcel from './ProjectAndCrExcel';
import UnfreezeRequestExcel from './UnfreezeRequestExcel';
import RMAllocationExcel from './RMAllocationExcel';
import ResourceHolidaysExcel from './ResourceHolidaysExcel';
import Loader from '../../integration/components/Loader';
import { LOG_TYPES } from "../../integration/IntegrationEnums";
import * as loggerService from "../../integration/LoggerService";
import { saveAuditTrail } from '../../integration/auditTrail/AuditTrailService';
import { DatePicker } from '@progress/kendo-react-dateinputs';
import moment from 'moment';
import 'moment-timezone';

export const ReportTypeEnum = [
  { id: 1, Name: 'Project List' },
  { id: 2, Name: 'Unfreeze Requests' },
  { id: 3, Name: 'Allocation History List' },
  { id: 4, Name: 'Resource Holidays' }
];

export const UnfreezeRequestEnum = [
  { id: 1, Name: 'Time Entry' },
  { id: 2, Name: 'Time Approval' }
];

class PMOReport extends Component {
    isMount = false;
    constructor(props) {
        super(props);
        this.state = {
            reportTypes: ReportTypeEnum,
            selectedReportType: null,
            projectData: [],
            crData: [],
            excelDownload: false,
            unfreezeRequestTypes: UnfreezeRequestEnum,
            selectedUnfreezeRequestType: null,
            unfreezeStartDate: null,
            unfreezeEndDate: null,
            unfreezeExcelDownload: false,
            unfreezeRequestData: [],
            rmAllocationDate: null,
            rmAllocationData: [],
            rmAllocationExcelDownload: false,
            resourceHolidaysStartDate: null,
            resourceHolidaysEndDate: null,
            resourceHolidaysData: [],
            resourceHolidaysExcelDownload: false,
            isErrorMessageVisible: false,
            loading: false
        };
    }

    componentDidMount() {
        this.isMount = true;
        this.props.onHeaderTitleChange('PMO Report');
    }

    componentWillUnmount() {
        this.isMount = false;
    }

    handleReportTypeChange = (event) => {
        const valueObj = event.target.value;
        if (this.isMount) {
            this.setState({
               selectedReportType: valueObj,
               isErrorMessageVisible: false
            });
        }
    };

    handleRequestTypeChange = (event) => {
        const valueObj = event.target.value;
        if (this.isMount) {
            this.setState({
               selectedUnfreezeRequestType: valueObj,
            });
        }
    };

    handleDateChange = event => {
        const field = event.target.name;
        let value = event.target.value;
        if (this.isMount) {
            this.setState({
                [field]: value
            });
        }
    };

    handleSubmit = async(e) => {
        e.preventDefault();
        if (!this.state.selectedReportType) {
            this.setState({ isErrorMessageVisible: true });
            return;
        }

        if (this.state.selectedReportType.id === 1) {
            this.getProjectAndCrListData();
        }

        if (this.state.selectedReportType.id === 2) {
            this.getUnfreezeRequestData();
        }

        if (this.state.selectedReportType.id === 3) {
            this.getRMAllocationData();
        }

        if (this.state.selectedReportType.id === 4) {
            this.getResourceHolidaysData();
        }
    };

    onClickCancel = () => {
        this.setState({ 
            selectedReportType: null,
            unfreezeEndDate: null,
            unfreezeStartDate: null,
            selectedUnfreezeRequestType: null,
            rmAllocationDate: null,
            resourceHolidaysStartDate: null,
            resourceHolidaysEndDate: null,
            isErrorMessageVisible: false 
        });
    };

    getProjectAndCrListData = async () => {
        this.setState({ 
            loading: true 
        }); 
        await getProjectAndCrListData().then(response => {
            this.setState({
                projectData: response.data.Projects,
                crData: response.data.ChangeRequests,
                excelDownload: true,
            });
            })
        .catch(error => {
            loggerService.writeLog(error, LOG_TYPES.ERROR);
        });
        this.setState({ 
            loading: false 
        });
    }

    getUnfreezeRequestData = async () => {
        this.setState({ 
            loading: true 
        });

        if (!this.state.selectedUnfreezeRequestType || !this.state.unfreezeStartDate || !this.state.unfreezeEndDate) {
            this.setState({ 
                isErrorMessageVisible: true,
                loading: false 
            });
            return;
        }

        const unfreezeObj = {
            RequestType: this.state.selectedUnfreezeRequestType.id,
            StartDate: moment(this.state.unfreezeStartDate).format("MM-DD-YYYY"),
            EndDate: moment(this.state.unfreezeEndDate).format("MM-DD-YYYY")
        }

        await getUnfreezeRequestData(unfreezeObj).then(response => {
            this.setState({
                unfreezeRequestData: response.data,
                unfreezeExcelDownload: true,
            });
            })
        .catch(error => {
            loggerService.writeLog(error, LOG_TYPES.ERROR);
        });
        this.setState({ 
            loading: false 
        });
    }

    getRMAllocationData = async () => {
        this.setState({ 
            loading: true 
        });

        if (!this.state.rmAllocationDate) {
            this.setState({ 
                isErrorMessageVisible: true,
                loading: false 
            });
            return;
        }

        const rmAllocationObj = {
            EndDateFilter: moment(this.state.rmAllocationDate).format("YYYY-MM-DD")
        }

        await getRMAllocationData(rmAllocationObj).then(response => {
            this.setState({
                rmAllocationData: response.data,
                rmAllocationExcelDownload: true,
            });
            })
        .catch(error => {
            loggerService.writeLog(error, LOG_TYPES.ERROR);
        });
        this.setState({ 
            loading: false 
        });
    }

    getResourceHolidaysData = async () => {
        this.setState({ 
            loading: true 
        });

        if (!this.state.resourceHolidaysStartDate || !this.state.resourceHolidaysEndDate) {
            this.setState({ 
                isErrorMessageVisible: true,
                loading: false 
            });
            return;
        }

        const resourceHolidaysObj = {
            StartDate: moment(this.state.resourceHolidaysStartDate).format("YYYY-MM-DD"),
            EndDate: moment(this.state.resourceHolidaysEndDate).format("YYYY-MM-DD")
        }

        await getResourceHolidaysData(resourceHolidaysObj).then(response => {
            this.setState({
                resourceHolidaysData: response.data,
                resourceHolidaysExcelDownload: true,
            });
            })
        .catch(error => {
            loggerService.writeLog(error, LOG_TYPES.ERROR);
        });
        this.setState({ 
            loading: false 
        });
    }

    validateProperty = value => {
        if (value) {
            return 'd-none';
        } else {
            return 'inline-error';
        }
    };

    render() {
        return (
            <div className="main-card">
                <div className="row">
                    <div className="col-md-9">
                        <div className="main-heading">PMO Reports</div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-4">
                        <div className="d-block">
                            <label>Report Type:</label>
                        </div>
                        <div className="">
                            <ComboBox
                              placeholder="Please Select"
                              data={this.state.reportTypes}
                              value={this.state.selectedReportType}
                              textField="Name"
                              dataItemKey="id"
                              onChange={this.handleReportTypeChange}
                              name="selectedReportType"
                              filterable={true}
                            />                            
                            {this.state.isErrorMessageVisible === true ? (
                                <span className={this.validateProperty(this.state.selectedReportType)}>
                                    Please select a Report Type
                                </span>
                            ) : null}
                        </div>
                    </div>
                </div>

                {this.state.selectedReportType && this.state.selectedReportType.id === 3 && (
                    <div className="row">
                        <div className="col-md-4">
                            <div className="d-block">
                                <label>Allocation End Date (On or After):</label>
                            </div>
                            <div className="">
                                <DatePicker
                                    width="100%"
                                    value={this.state.rmAllocationDate}
                                    onChange={this.handleDateChange}
                                    name="rmAllocationDate"
                                    format="MM/dd/yyyy"
                                    formatPlaceholder={{ year: 'YYYY', month: 'MM', day: 'DD' }}
                                    min={new Date("2019-01-01")}
                                />                            
                                {this.state.isErrorMessageVisible === true ? (
                                    <span className={this.validateProperty(this.state.rmAllocationDate)}>
                                        Please select a Date
                                    </span>
                                ) : null}
                            </div>
                        </div>
                    </div>
                )}

                {this.state.selectedReportType && this.state.selectedReportType.id === 2 && (
                    <div className="row">
                        <div className="col-md-4">
                            <div className="d-block">
                                <label>Request Type:</label>
                            </div>
                            <div className="">
                                <ComboBox
                                    placeholder="Please Select"
                                    data={this.state.unfreezeRequestTypes}
                                    value={this.state.selectedUnfreezeRequestType}
                                    textField="Name"
                                    dataItemKey="id"
                                    onChange={this.handleRequestTypeChange}
                                    name="selectedReportType"
                                    filterable={true}
                                />                            
                                {this.state.isErrorMessageVisible === true ? (
                                    <span className={this.validateProperty(this.state.selectedUnfreezeRequestType)}>
                                        Please select a Request Type
                                    </span>
                                ) : null}
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="d-block">
                                <label>Start Date:</label>
                            </div>
                            <div className="">
                                <DatePicker
                                    width="100%"
                                    value={this.state.unfreezeStartDate}
                                    onChange={this.handleDateChange}
                                    name="unfreezeStartDate"
                                    format="MM/dd/yyyy"
                                    formatPlaceholder={{ year: 'YYYY', month: 'MM', day: 'DD' }}
                                    min={new Date("2020-01-01")}
                                />                            
                                {this.state.isErrorMessageVisible === true ? (
                                    <span className={this.validateProperty(this.state.unfreezeStartDate)}>
                                        Please select a Start Date
                                    </span>
                                ) : null}
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="d-block">
                                <label>End Date:</label>
                            </div>
                            <div className="">
                                <DatePicker
                                    width="100%"
                                    value={this.state.unfreezeEndDate}
                                    onChange={this.handleDateChange}
                                    name="unfreezeEndDate"
                                    format="MM/dd/yyyy"
                                    formatPlaceholder={{ year: 'YYYY', month: 'MM', day: 'DD' }}
                                    min={this.state.unfreezeStartDate ? new Date(this.state.unfreezeStartDate) : new Date("2020-01-01")}
                                />                            
                                {this.state.isErrorMessageVisible === true ? (
                                    <span className={this.validateProperty(this.state.unfreezeEndDate)}>
                                        Please select a End Date
                                    </span>
                                ) : null}
                            </div>
                        </div>
                    </div>
                )}

                {this.state.selectedReportType && this.state.selectedReportType.id === 4 && (
                    <div className="row">
                        <div className="col-md-4">
                            <div className="d-block">
                                <label>Start Date:</label>
                            </div>
                            <div className="">
                                <DatePicker
                                    width="100%"
                                    value={this.state.resourceHolidaysStartDate}
                                    onChange={this.handleDateChange}
                                    name="resourceHolidaysStartDate"
                                    format="MM/dd/yyyy"
                                    formatPlaceholder={{ year: 'YYYY', month: 'MM', day: 'DD' }}
                                    min={new Date("2019-01-01")}
                                />                            
                                {this.state.isErrorMessageVisible === true ? (
                                    <span className={this.validateProperty(this.state.resourceHolidaysStartDate)}>
                                        Please select a Start Date
                                    </span>
                                ) : null}
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="d-block">
                                <label>End Date:</label>
                            </div>
                            <div className="">
                                <DatePicker
                                    width="100%"
                                    value={this.state.resourceHolidaysEndDate}
                                    onChange={this.handleDateChange}
                                    name="resourceHolidaysEndDate"
                                    format="MM/dd/yyyy"
                                    formatPlaceholder={{ year: 'YYYY', month: 'MM', day: 'DD' }}
                                    min={this.state.resourceHolidaysStartDate ? new Date(this.state.resourceHolidaysStartDate) : new Date("2019-01-01")}
                                />                            
                                {this.state.isErrorMessageVisible === true ? (
                                    <span className={this.validateProperty(this.state.resourceHolidaysEndDate)}>
                                        Please select an End Date
                                    </span>
                                ) : null}
                            </div>
                        </div>
                    </div>
                )}

                <div className="row">
                    <div className="col-md-12 mt-2 btn-align-right">
                        <Button primary={true} type="submit" onClick={this.handleSubmit}>
                            Submit
                        </Button>
                        <Button type="button" onClick={this.onClickCancel} style={{ marginRight: '5px' }}>
                            Cancel
                        </Button>
                        {!this.state.loading && this.state.selectedReportType && this.state.selectedReportType.id === 1 && (
                            <ProjectAndCrExcel
                                projectData={this.state.projectData}
                                crData={this.state.crData}
                                updateData={this.state.excelDownload}
                                dataUpdated={() => {
                                    this.setState({ excelDownload: false });
                                    const auditTrail = {
                                        Action: 'Project and CR List report downloaded',
                                        RefType: 'PMO Reports',
                                        RefId: window.LOGGED_USER.user,
                                        RefName: window.LOGGED_USER.displayName
                                    }
                                    saveAuditTrail(auditTrail)
                                }}
                            />
                        )}
                        {!this.state.loading && this.state.selectedReportType && this.state.selectedReportType.id === 2 && (
                            <UnfreezeRequestExcel
                                unfreezeRequestData={this.state.unfreezeRequestData}
                                startDate={this.state.unfreezeStartDate}
                                endDate={this.state.unfreezeEndDate}
                                updateData={this.state.unfreezeExcelDownload}
                                dataUpdated={() => {
                                    this.setState({ unfreezeExcelDownload: false });
                                    const auditTrail = {
                                        Action: 'Unfreeze requests report downloaded',
                                        RefType: 'PMO Reports',
                                        RefId: window.LOGGED_USER.user,
                                        RefName: window.LOGGED_USER.displayName
                                    }
                                    saveAuditTrail(auditTrail)
                                }}
                            />
                        )}
                        {!this.state.loading && this.state.selectedReportType && this.state.selectedReportType.id === 3 && (
                            <RMAllocationExcel
                                rmAllocationData={this.state.rmAllocationData}
                                endDateFilter={this.state.rmAllocationDate}
                                updateData={this.state.rmAllocationExcelDownload}
                                dataUpdated={() => {
                                    this.setState({ rmAllocationExcelDownload: false });
                                    const auditTrail = {
                                        Action: 'Allocation History List report downloaded',
                                        RefType: 'PMO Reports',
                                        RefId: window.LOGGED_USER.user,
                                        RefName: window.LOGGED_USER.displayName
                                    }
                                    saveAuditTrail(auditTrail)
                                }}
                            />
                        )}
                        {!this.state.loading && this.state.selectedReportType && this.state.selectedReportType.id === 4 && (
                            <ResourceHolidaysExcel
                                resourceHolidaysData={this.state.resourceHolidaysData}
                                startDate={this.state.resourceHolidaysStartDate}
                                endDate={this.state.resourceHolidaysEndDate}
                                updateData={this.state.resourceHolidaysExcelDownload}
                                dataUpdated={() => {
                                    this.setState({ resourceHolidaysExcelDownload: false });
                                    const auditTrail = {
                                        Action: 'Resource Holidays report downloaded',
                                        RefType: 'PMO Reports',
                                        RefId: window.LOGGED_USER.user,
                                        RefName: window.LOGGED_USER.displayName
                                    }
                                    saveAuditTrail(auditTrail)
                                }}
                            />
                        )}
                    </div>
                </div>  
                <Loader loading={this.state.loading} />          
            </div>
        );
    }
}

export default PMOReport;